export default __webpack_public_path__ + "static/media/windows_building.b1e4c323.jpg";